import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

/////////// export all ///////////////////////////////////////////////
export default function* generalSaga() {
  yield all([
    // fork(watchGetUserInfo),
  ])
}